import React from "react";
import "./styles.css";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import "react-google-places-autocomplete/dist/index.min.css";
import { usePosition } from "use-position";
const Component = () => {
  const { latitude, longitude } = usePosition();
  return (
    <div className="main">
      <div className="header">
<h1>Welcome to Google Places API example by Gunish Matta </h1>
      <h3>Enter the Address of the Business You want to search </h3>
     </div>
      <GooglePlacesAutocomplete
        autocompletionRequest={{
          location: { lat: longitude, lng: latitude },
          radius: 5,
          type: "establishment",
          debounce: 1500,
          className : {
            container: 'search-bar' }
        
        }}
      />
    </div>
  );
};

export default Component;
